import { AsyncRequestStatus, getDefaultAsyncWrapperObj } from '@ane/core/lib/models/IAsyncWrapper';
import { loadControlTowerExperienceActionTypes, flightDetailsActionTypes, } from '../components/FlightDetails/FlightDetails.ducks';
import { loadOverviewActionTypes } from './FlightOverview.ducks';
import { loadScorecardActionTypes, } from '../components/FlightExperiments/FlightExperimentList.ducks';
import { loadFlightVariablesActionTypes } from '../components/FlightVariables/FlightVariables.ducks';
import { loadFlightTrafficActionTypes } from '../components/FlightTraffic/FlightTraffic.ducks';
import { updateFlightActionTypes, loadPathsActionTypes, } from '../components/FlightEdit/FlightEdit.ducks';
import { loadFlightControlActionTypes } from '../components/FlightDetails/FlightDetails.ducks';
import { updateCompostionActionTypes, compositionEditActionTypes, loadCompositionEpicReducer, loadDependencyEpicReducer, queryFlightEpicReducer, } from '../components/Composition/Composition.ducks';
export const defaultFlightDetailsReducerState = {
    flightDataById: {},
    flightQueries: {},
};
export const defaultFlightReducerState = {
    flightOverview: getDefaultAsyncWrapperObj(),
    scorecardDataResult: getDefaultAsyncWrapperObj(),
    flightVariableResults: getDefaultAsyncWrapperObj(),
    updateResult: getDefaultAsyncWrapperObj(),
    flightControl: getDefaultAsyncWrapperObj(),
    controlTowerExperience: getDefaultAsyncWrapperObj(),
    managementGroupPaths: getDefaultAsyncWrapperObj(),
    flightTraffic: getDefaultAsyncWrapperObj(),
    composition: getDefaultAsyncWrapperObj(),
    dependencies: getDefaultAsyncWrapperObj(),
    compositionUpdate: { request: getDefaultAsyncWrapperObj() },
    compositionResultMessage: { message: null },
};
// Reducer
export const flightReducerById = (state = defaultFlightDetailsReducerState, action) => {
    var _a;
    state = queryFlightEpicReducer.reduxChange(state, action);
    switch (action.type) {
        case flightDetailsActionTypes.SET_CURRENT_FLIGHT:
            return Object.assign({}, state);
        default:
            if (!!((_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.flightId)) {
                return Object.assign(Object.assign({}, state), { flightDataById: Object.assign(Object.assign({}, state.flightDataById), { [action.payload.flightId]: flightReducer(state.flightDataById[action.payload.flightId], action) }) });
            }
            return Object.assign({}, state);
    }
};
export const flightReducer = (state = defaultFlightReducerState, action) => {
    state = loadCompositionEpicReducer.reduxChange(state, action);
    state = loadDependencyEpicReducer.reduxChange(state, action);
    switch (action.type) {
        case flightDetailsActionTypes.RESET_STATE:
            return Object.assign(Object.assign({}, state), defaultFlightReducerState);
        case loadOverviewActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { flightOverview: Object.assign(Object.assign({}, state.flightOverview), { status: AsyncRequestStatus.Pending }) });
        case loadOverviewActionTypes.LOADED:
            const overviewResult = action;
            return Object.assign(Object.assign({}, state), { flightOverview: overviewResult.payload.result });
        case loadScorecardActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { scorecardDataResult: Object.assign(Object.assign({}, state.scorecardDataResult), { status: AsyncRequestStatus.Pending }) });
        case loadScorecardActionTypes.LOADED:
            const scorecardResult = action;
            return Object.assign(Object.assign({}, state), { scorecardDataResult: scorecardResult.payload.result });
        case loadFlightVariablesActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { flightVariableResults: Object.assign(Object.assign({}, state.flightVariableResults), { status: AsyncRequestStatus.Pending }) });
        case loadFlightVariablesActionTypes.LOADED:
            const variablesResult = action;
            return Object.assign(Object.assign({}, state), { flightVariableResults: variablesResult.payload.result });
        case updateFlightActionTypes.UPDATING: {
            return Object.assign(Object.assign({}, state), { updateResult: Object.assign(Object.assign({}, state.updateResult), { status: AsyncRequestStatus.Pending }) });
        }
        case updateFlightActionTypes.UPDATED: {
            const updatePayload = action;
            return Object.assign(Object.assign({}, state), { updateResult: updatePayload.payload.result });
        }
        case updateFlightActionTypes.CANCEL_UPDATE: {
            return Object.assign(Object.assign({}, state), { updateResult: { status: AsyncRequestStatus.NotStarted } });
        }
        case loadFlightControlActionTypes.LOADING: {
            return Object.assign(Object.assign({}, state), { flightControl: Object.assign(Object.assign({}, state.flightControl), { status: AsyncRequestStatus.Pending }) });
        }
        case loadFlightControlActionTypes.LOADED: {
            const flightControlPayload = action;
            return Object.assign(Object.assign({}, state), { flightControl: flightControlPayload.payload.flightControl });
        }
        case loadPathsActionTypes.LOADING: {
            return Object.assign(Object.assign({}, state), { managementGroupPaths: Object.assign(Object.assign({}, state.managementGroupPaths), { status: AsyncRequestStatus.Pending }) });
        }
        case loadPathsActionTypes.LOADED: {
            const pathsPayload = action;
            return Object.assign(Object.assign({}, state), { managementGroupPaths: pathsPayload.payload.paths });
        }
        case loadFlightTrafficActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { flightTraffic: Object.assign(Object.assign({}, state.flightTraffic), { status: AsyncRequestStatus.Pending }) });
        case loadFlightTrafficActionTypes.LOADED:
            const loadFlightTrafficAction = action;
            return Object.assign(Object.assign({}, state), { flightTraffic: {
                    data: loadFlightTrafficAction.payload.data,
                    status: AsyncRequestStatus.Completed,
                    error: loadFlightTrafficAction.payload.error,
                } });
        case loadControlTowerExperienceActionTypes.LOADING: {
            return Object.assign(Object.assign({}, state), { controlTowerExperience: Object.assign(Object.assign({}, state.controlTowerExperience), { status: AsyncRequestStatus.Pending }) });
        }
        case loadControlTowerExperienceActionTypes.LOADED: {
            const experiencePayload = action;
            return Object.assign(Object.assign({}, state), { controlTowerExperience: experiencePayload.payload.controlTowerExperience });
        }
        case updateCompostionActionTypes.UPDATING: {
            const compositionUpdate = action;
            return Object.assign(Object.assign({}, state), { compositionUpdate: Object.assign(Object.assign({}, state.compositionUpdate), { isVerifyOnly: compositionUpdate.payload.verifyOnly, request: Object.assign(Object.assign({}, state.compositionUpdate.request), { status: AsyncRequestStatus.Pending }) }) });
        }
        case updateCompostionActionTypes.UPDATED: {
            const compositionUpdate = action;
            const { result, verifyOnly, submissionMessage, isVerificationSuccess } = compositionUpdate.payload;
            return Object.assign(Object.assign({}, state), { dependencies: !!result.error ? state.dependencies : result, compositionUpdate: { isVerifyOnly: verifyOnly, request: result }, compositionResultMessage: { message: submissionMessage, isVerificationSuccess: isVerificationSuccess } });
        }
        case compositionEditActionTypes.RESET_EDIT: {
            return Object.assign(Object.assign({}, state), { dependencies: { status: AsyncRequestStatus.NotStarted } });
        }
        case compositionEditActionTypes.DISMISS_MESSAGE: {
            return Object.assign(Object.assign({}, state), { compositionResultMessage: { message: null } });
        }
        default:
            return state;
    }
};
export default flightReducerById;

//# sourceMappingURL=FlightDetails.reducer.js.map
